<template>
  <v-dialog
    :value="enableDialog"
    persistent
    width="550"
  >
    <validation-observer ref="observer">
      <v-card>
        <v-card-title>
          車両の登録
        </v-card-title>
        <v-divider />
        <v-card-text>
          <validation-provider
            v-slot="{ errors }"
            class="requiredMark"
            name="車両"
            rules="required|max:3000"
          >
            <v-select
              v-model="forms.vehicle_id"
              :error-messages="errors"
              :items="vehicles"
              dense
              hide-details="auto"
              outlined
              style="font-size: 90%"
              @change="vehicleChangeEvent"
            />
          </validation-provider>
        </v-card-text>
        <v-divider />
        <v-card-actions>
          <v-spacer />
          <v-btn
            @click="closeButtonClickEvent"
          >
            閉じる
          </v-btn>
          <v-btn
            color="primary"
            @click="registerButtonClickEvent"
          >
            登録
          </v-btn>
        </v-card-actions>
      </v-card>
    </validation-observer>
  </v-dialog>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'AllocationDriverScheduleVehicleDialog',
  components: {},
  mixins: [],
  props: {
    enableDialog: {
      type: Boolean,
      default: () => false,
    },
    targetDriverId: {
      type: Number,
      default: () => null,
    },
    targetScheduleDetailId: {
      type: Number,
      default: () => null,
    },
    targetDate: {
      type: String,
      default: () => null,
    }
  },
  data () {
    return {
      forms: {
        vehicle_id: null,
        vehicle_name: null,
        vehicle_number: null,
        confirmed_at: null,
      },
      vehicles: [],
    }
  },
  computed: {},
  watch: {
    enableDialog (newValue) {
      this.$nextTick(() => this.$refs.observer.reset())
      Object.assign(this.$data.forms, this.$options.data().forms);
      if (newValue) {
        this.setVariable()
      }
    },
  },
  created() {
  },
  methods: {
    ...mapActions('DriverMasterSearchVehicle', {
      fetchVehicles: 'index',
    }),
    ...mapActions('DriverAllocationDriverScheduleVehicle', {
      fetchScheduleDetail: 'edit',
      updateScheduleDetail: 'update',
    }),
    /**
     * 閉じるボタン クリックイベント
     */
    closeButtonClickEvent () {
      this.$emit('closeEvent')
    },
    /**
     * 登録ボタン クリックイベント
     */
    registerButtonClickEvent () {
      let $self = this
      this.$refs.observer.validate().then((result) => {
        if(result){
          $self.sendRegistrationInformation()
        }
      })
    },
    sendRegistrationInformation() {
      let params = { vehicle_id: this.forms.vehicle_id, target_date: this.targetDate }
      this.updateScheduleDetail({ driver_id: this.targetDriverId, schedule_detail_id: this.targetScheduleDetailId, params: params }).then(() => {
        this.$emit('registerEvent', this.targetDriverId, this.targetScheduleDetailId, this.forms)
      })
    },
    /**
     * 初期値設定
     */
    setVariable() {
      this.fetchVehicles().then((content) => {
        this.vehicles = content.vehicles
      })
      this.fetchScheduleDetail({ driver_id: this.targetDriverId, schedule_detail_id: this.targetScheduleDetailId, target_date: this.targetDate}).then((content) => {
        this.forms = content
      })
    },
    vehicleChangeEvent () {
      const vehicle = this.vehicles.find(v => v.value === this.forms.vehicle_id)
      if (vehicle) {
        this.forms.vehicle_name = vehicle.text
        this.forms.vehicle_number = vehicle.number
      }
    }
  }
}
</script>
